import { useT } from "../i18n/index.js";

/**
 * Banner IMBORRABLE para baterías de PRUEBA (QA): deja claro que el (pre)informe
 * NO tiene validez clínica. Se muestra en la mesa de revisión (terapeuta) y en
 * ambas variantes del informe (padre y terapeuta). No es descartable a propósito.
 */
export function QaBanner() {
  const t = useT();
  return (
    <div
      role="alert"
      style={{
        background: "var(--danger)",
        color: "#fff",
        fontWeight: 800,
        textAlign: "center",
        padding: "10px 14px",
        borderRadius: 10,
        letterSpacing: 0.3,
        marginBottom: 12,
      }}
    >
      ⚠️ {t("qa.banner")}
    </div>
  );
}
